export default "__VITE_ASSET__3DHKbXyC__"